import LiquidRender, { LiquidTemplates } from '@gate31/uikit/common/scripts/liquid-render';
import { ModalDesk } from '../ModalDesk/ModalDesk';

interface templateDataIng {
    local: {
        title?: string;
        content?: string;
    };
    global: {
        title?: string;
        content?: string;
    };
}

export class TableSizeDesk {
    template: keyof LiquidTemplates;
    trigger: HTMLDivElement;
    templateData: templateDataIng;
    modal: ModalDesk;

    constructor({ template, trigger, templateData }: { template: keyof LiquidTemplates; trigger: HTMLDivElement; templateData: templateDataIng }) {
        this.template = template;
        this.trigger = trigger;
        this.templateData = templateData;

        this.connectionCallback();
    }

    connectionCallback() {
        this.createModal();

        this.trigger.addEventListener('click', () => {
            this.open();
        });
    }

    getModalContent(): string {
        return LiquidRender.render(this.template, this.templateData);
    }

    createModal() {
        const content = this.getModalContent();

        this.modal = new ModalDesk({
            template: 'modal-desk-template',
            content,
            disableBodyScroll: true,
            viewOpts: {
                closeIconSize: 'm'
            }
        });
    }

    open() {
        this.modal.open();
    }
}
